import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Alert} from '../../look';

class GraphQlError extends Component {
  render() {
    const {children, ...rest} = this.props;

    return (
      <Alert color="error" {...rest}>
        {children.name !== 'ManyErrorMessages' ? (
          <b>{children.message}</b>
        ) : (
          children.data.messages.map((message, messageIndex) => <div key={messageIndex}>{message}</div>)
        )}
      </Alert>
    );
  }
}

GraphQlError.propTypes = {
  children: PropTypes.any,
};

export default GraphQlError;
